import login from './login';

export default {
  language: 'ro-RO',
  country: 'ro',
  name: 'Română',
  embeddedLocale: login,
};
